import { z } from 'zod'
import ApiService from '../api.service'

export type AEJ = {
    id: string
    filename: string
    dataInicial: string
    dataFinal: string
    createdAt: Date
}

export const CreateAejSchema = z.object({
    empresaId: z.number().nullish(),
    competencia: z.string().nonempty('Obrigatório'),
    dataInicial: z.string().nonempty('Obrigatório'),
    dataFinal: z.string().nonempty('Obrigatório'),
})

export type CreateAej = z.infer<typeof CreateAejSchema>

export const aej = new ApiService<CreateAej, AEJ>('aej')
